import { render, staticRenderFns } from "./doctorList.vue?vue&type=template&id=954cd332&scoped=true&"
import script from "./doctorList.vue?vue&type=script&lang=js&"
export * from "./doctorList.vue?vue&type=script&lang=js&"
import style0 from "./doctorList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./doctorList.vue?vue&type=style&index=1&id=954cd332&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "954cd332",
  null
  
)

export default component.exports